module.exports = __webpack_public_path__ + "img/illustration-help.56e52b3b.svg";